/**
 *  このファイルはtools/generate.tsにより生成されたファイルです。手動で編集しないでください。
 */

import { EntityDataApi } from "../../IndexedDBApi";
import { MixRatioDetailBase } from "../../../../schema/generated/MixRatioDetail";
import { idbEntityDefs } from "../../generated/entityDefs";

// 固有処理を持たない薄いDataApi。共通CRUD/キャッシュはEntityDataApiに集約。
export class MixRatioDetailDataApi extends EntityDataApi<MixRatioDetailBase> {
  public readonly def = idbEntityDefs.MixRatioDetail;
}